import { useQuery } from "@apollo/client"
import { Chip } from "@heroui/react"
import { ErrorPlaceholder, LoadingPlaceholder, SimplePlaceholder } from "@components"
import { CircleStackIcon } from "@heroicons/react/24/outline"
import { GET_STAFF_LESSONS } from "@graphql"
import PropTypes from "prop-types"

const StaffLessonsList = ({ staffMember }) => {
  const { loading, error, data } = useQuery(GET_STAFF_LESSONS, {
    variables: {
      fetchPolicy: "cache-first",
      id: staffMember.id,
    },
  })
  
  if (loading) return <LoadingPlaceholder caption="Loading lessons..." icon={CircleStackIcon} />

  if (error) return <ErrorPlaceholder caption="There was an error loading the lessons for this member of staff." error={error} />

  if (data.staffMember.lessons.length === 0) {
    return (
      <SimplePlaceholder isFullHeight={false} icon={CircleStackIcon} title="No lessons found for this staff member">
        <p className="mt-1 text-sm text-gray-500">
          If you believe this member of staff should have associated lessons then please check your MIS and Xporter
          integration.
        </p>
      </SimplePlaceholder>
    )
  }

  return (
    <div>
      <Chip className="float-right" color="primary">
        {data.staffMember.lessons.length} lessons
      </Chip>

      <ul className="clear-right divide-y divide-gray-300 dark:divide-content2-foreground divide-dotted">
        {data.staffMember.lessons.map(lesson => (
          <li key={lesson.id} className="flex justify-between py-3">
            {lesson.name}
          </li>
        ))}
      </ul>
    </div>
  )
}

StaffLessonsList.propTypes = {
  staffMember: PropTypes.object.isRequired,
}

export default StaffLessonsList
